// © Microsoft Corporation. All rights reserved.
import { invoke } from "../SapphireCore";
export function loadData(data, callback) {
    invoke("loadData", data, callback);
}
/**
 * Load data from internal database.
 * @param data parameters for method "loadData".
 */
export function loadDataAsync(data) {
    return new Promise((resolve, reject) => {
        loadData(data, (result) => {
            resolve(result);
        });
    });
}
export function saveData(data, callback) {
    invoke("saveData", data, callback);
}
/**
 * Save simple data to internal database.
 * @param data parameters for method "saveData".
 */
export function saveDataAsync(data) {
    return new Promise((resolve, reject) => {
        saveData(data, (result) => {
            resolve(result);
        });
    });
}
export function manageData(data, callback) {
    invoke("requestShare", data, callback);
}
/**
 * Manage internal database.
 * @param data parameters for method "manageData".
 */
export function manageDataAsync(data) {
    return new Promise((resolve, reject) => {
        manageData(data, (result) => {
            resolve(result);
        });
    });
}
//# sourceMappingURL=Data.js.map